import React, { useContext, useEffect, useState } from 'react';
import { Switch, Redirect, Route, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';

import RefreshHandler from './RefreshHandler';
// context
import { UserContext } from './context';

// components
import {
  SignUp,
  SignIn,
  SignOut,
  Forgot,
  Dashboard,
  InsightReport,
  Interstitial,
  OptimisationDashboard,
  KpiOptimize,
  ImportCampaign,
  GenerateReports,
  DefineReportsDataContainer,
  FinalReport,
  BrandLiftStudy,
  AddBrandLiftStudy,
  ViewBrandLiftStudy,
  LinkAccounts,
  MalaRedirect,
  PDFUpload,
} from './components/organisms';
import { AdminDashboard, AccountDetails } from './components/admin/organisms';
import { RecommendationResults } from './components/molecules';
import { Loader } from './components/atoms';
import ReportMetrics from './components/molecules/report-metrics/report-metrics';
import MSAuthenticate from './ms-authenticate';
import { MS_AUTHENTICATE } from './utils/routes';
import AddCatalogPdf from './components/organisms/add-catalog-pdf/add-cataloga-pdf';
import { UpaSession } from './components/organisms/upa-session/UpaSession';
// import  from './components/organisms/generate-reports/generate-reports';

function App() {
   
  let parsedUserData = null
try {
  let  data = localStorage.getItem('user')
  if (data) {
    parsedUserData = JSON.parse(data)
  }
} catch (error) {
  console.error('Error parsing data from localStorage:', error)
}

  const history = useHistory();
  let location = useLocation();
  const { user, setUser } = useContext(UserContext);
  const [authenticated, setAuthenticated] = useState(parsedUserData?.authenticated);
  const [insights, setInsights] = useState(user?.insights);
  const [loader, setLoader] = useState(null);
  const [isAdmin, setisAdmin] = useState(user?.role);



  useEffect(() => {
    let title = history?.location?.pathname.slice(1);
    title = title.charAt(0).toUpperCase() + title.slice(1);
    document.title = title ? `Meta Insights Automation - ${title}` : 'Meta Insights Automation';
    
    if (user?.authenticated || parsedUserData?.authenticated) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
    }
    let roleSet = user?.role === 'ADMIN' || user?.role === 'SUPERADMIN' ? setisAdmin(true) : setisAdmin(false);

    //console.log('App Refreshed...', user);
  }, [user, history, parsedUserData?.authenticated]);

  // Handle back/forward navigation showing stale cached pages
  useEffect(() => {
    function checkAuthAndRedirect() {
      const storedUserStr = localStorage.getItem('user');
      let storedUser = null;
      try {
        storedUser = storedUserStr ? JSON.parse(storedUserStr) : null;
      } catch (e) {
        storedUser = null;
      }
      const isAuthenticated = !!(user?.authenticated || storedUser?.authenticated);
      if (!isAuthenticated) {
        if (history?.location?.pathname !== '/signIn' && history?.location?.pathname !== '/signOut' && history?.location?.pathname !== '/forgot' && history?.location?.pathname !== '/upasession') {
          history.replace('/signIn');
        }
      }
    }

    // On popstate (back/forward) and on pageshow (including BFCache restore)
    const handlePopState = () => checkAuthAndRedirect();
    const handlePageShow = (event) => {
      if (event.persisted) {
        checkAuthAndRedirect();
      }
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('pageshow', handlePageShow);
    // Run once on mount
    checkAuthAndRedirect();

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [user, history]);

  //loader usereffects
  useEffect(() => {
    axios.interceptors.request.use(
      function (config) {
        setLoader(true);
        if (user?.lionLoginInfo) {
          config.headers['x-source'] = 'sso';
        }
        return config;
      },
      function (error) {
        setLoader(false);
        return Promise.reject(error);
      }
    );

    // response interceptors
    axios.interceptors.response.use(
      function (response) {
        setLoader(false);
        return response;
      },
      function (error) {
        setLoader(false);
        if (error.response.status === 403) {
          history.push('/signIn');
          localStorage.removeItem('user');
          setUser(null);
        }
        return Promise.reject(error);
      }
    );

    // local storage session handling across tabs
    // const handleStorageChange = event => {
    //   if (event.type === 'storage') {
    //     const user = localStorage.getItem('user');
    //     if (!user) {
    //       setAuthenticated(false);
    //       history.push('/signIn');
    //       setUser(null);
    //     }
    //   }
    // };

    // window.addEventListener('storage', handleStorageChange);

    // return () => {
    //   window.removeEventListener('storage', handleStorageChange);
    // };
  }, []);

  return (
    <main className="h-screen mx-auto main-wrapper">
      {loader ? <Loader /> : null}
      <Switch>
         <Route
          exact
          path="/upasession"
          render={() => ( <UpaSession />)}
        />
        <Route path="/mala/" render={() => <MalaRedirect />} />
        <Route
          exact
          path={MS_AUTHENTICATE}
          render={() => (authenticated ? <Redirect to="/" /> : <MSAuthenticate />)}
        />
        <Route
          exact
          path="/signIn"
          render={() => (authenticated ? <Redirect to="/interstitial" /> : <SignIn />)}
        />
        <Route
          exact
          path="/signUp"
          render={() => (authenticated ? <Redirect to="/" /> : <SignUp />)}
        />
        <Route exact path="/signOut" component={SignOut} />
        <Route
          exact
          path="/forgot"
          render={() => (authenticated ? <Redirect to="/" /> : <Forgot />)}
        />
        <Route
          exact
          path="/interstitial"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <Interstitial />)}
        />
        <Route
          exact
          path="/optimization"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <OptimisationDashboard />)}
        />
        <Route
          exact
          path="/reports"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <GenerateReports />)}
        />
        <Route
          exact
          path="/report-output"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <FinalReport />)}
        />
        <Route
          exact
          path="/define-report"
          render={() =>
            !authenticated ? <Redirect to="/signIn" /> : <DefineReportsDataContainer />
          }
        />
        <Route
          exact
          path="/report-metrics"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <ReportMetrics />)}
        />
        <Route
          exact
          path="/kpi-optimization"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <KpiOptimize />)}
        />
        <Route
          exact
          path="/import-campaigns"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <ImportCampaign />)}
        />
        <Route
          exact
          path="/recommendation"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <RecommendationResults />)}
        />
        <Route
          exact
          path="/bls_insights"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <BrandLiftStudy />)}
        />
        <Route
          exact
          path="/add-bls-study"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <AddBrandLiftStudy />)}
        />
        <Route
          exact
          path="/add-catalog-pdf"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <AddCatalogPdf />)}
        />
        <Route
          exact
          path="/view-bls-study"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <ViewBrandLiftStudy />)}
        />
        <Route
          exact
          path="/manage-accounts"
          render={() =>
            !authenticated ? (
              <Redirect to="/signIn" />
            ) : !isAdmin ? (
              <Redirect to="/interstitial" />
            ) : (
              <AdminDashboard />
            )
          }
        />
        <Route
          exact
          path="/account-details"
          render={() =>
            !authenticated ? (
              <Redirect to="/signIn" />
            ) : !isAdmin ? (
              <Redirect to="/interstitial" />
            ) : (
              <AccountDetails />
            )
          }
        />

        <Route path="/link-accounts" render={() => <LinkAccounts />} />
        {/* <Route path="/pdf-upload" render={() => <PDFUpload />} /> */}
        
        <Route
          path="/mala/"
          render={() => (!authenticated ? <MalaRedirect /> : <Interstitial />)}
        />

        <Route
          exact
          path="/"
          render={() => (!authenticated && !insights ? <Redirect to="/signIn" /> : <Dashboard />)}
        />
        <Route
          exact
          path="/:id"
          render={() => (!authenticated ? <Redirect to="/signIn" /> : <InsightReport />)}
        />

        <Redirect to="/signUp" />
      </Switch>
      {!location.pathname.match(/signOut|signUp|signIn|forgot|interstitial|upasession|mala/g) && <RefreshHandler />}
    </main>
  );
}

export default App;
